import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const messageBox = 'w-1/2 mx-auto border border-gray-400 rounded-lg my-3 px-2 py-1 text-center'

const MessageSystem = ({ message, updateAt, type }) => {
  return (
    <>
      <div className={clsx(messageBox, { 'bg-gray-800': type === 'system_message' })}>
        <span className="text-xs text-gray-600 font-medium">{message.content}</span>
      </div>
      <div className="flex w-full justify-center">
        <div className="mb-3 mt-1 text-xs text-gray-500">
          <span>{updateAt}</span>
        </div>
      </div>
    </>
  )
}

MessageSystem.propTypes = {
  message: PropTypes.object,
  updateAt: PropTypes.string,
  type: PropTypes.string,
}

export default MessageSystem
